<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="receipt icon"></i>
      {{ $t("emitter") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/fel_gt.jpg" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui two item top attached tabular menu" ref="tabss">
          <a class="active item" data-tab="certifier">
            <i class="address card icon"></i>
            {{ $t("emitter") }}</a
          >
          <a class="item" data-tab="receipt">
            <i class="receipt icon"></i> {{ $t("receipt") }}</a
          >
        </div>
        <div class="ui bottom attached active tab segment" data-tab="certifier">
          <div class="ui form">
            <div class="three fields">
              <div class="field">
                <label for>{{ $t("name") }}</label>
                <input type="text" name="name" v-model="meta.name" />
              </div>
              <div class="field">
                <label for>{{ $t("provider") }}</label>
                <div class="ui selection dropdown" ref="provider">
                  <input type="hidden" name="provider" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu">
                    <div class="item" data-value="g4s">G4S</div>
                    <div class="item" data-value="megaprint">Megaprint</div>
                  </div>
                </div>
              </div>
              <!-- <div class="field">
                <label for>
                  <i class="settings icon"></i>
                </label>
                <div class="ui toggle checkbox" ref="set_as_default_checkbox">
                  <input
                    type="checkbox"
                    name="set_as_default"
                    v-model="meta.set_as_default"
                  />
                  <label>{{ $t("set as default") }}</label>
                </div>
              </div> -->
            </div>
            <component
              :is="provider_component"
              @update="prov_setup_updated($event)"
              :setup_in="meta.setup"
              ref="provider_comp"
            ></component>
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="receipt">
          <wysywyg v-model="meta.template" ref="wysy" />
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
      <div class="ui left floated blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import { enterprise_setup, local_api, error_toast } from "@/utils";
import filters from "@/filters";
import G4SBilling from "./G4SBilling";
import MegaprintBilling from "./MegaprintBilling";
import Wysywyg from "@/components/Wysywyg/Wysywyg";
// import { translate_status, translate_type } from "../local_translator";
// import Voided from "./Void.vue";

// filters.translate_status = translate_status;
// filters.translate_type = translate_type;

export default {
  name: "FelGTEmitterModal",
  filters: filters,
  components: {
    Wysywyg,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
    provider_component() {
      let vm = this;
      // console.log("calculating provider component", vm.meta.provider);
      if (vm.meta.provider == "g4s") return G4SBilling;
      else if (vm.meta.provider == "megaprint") return MegaprintBilling;
      else return undefined;
    },
  },
  data() {
    return {
      uuid: "",
      meta: {
        name: "",
        provider: "",
        setup: {},
        template: {
          html: "",
          js: "",
          css: "",
        },
      },
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        // console.log(data);
        if (data.uuid) {
          local_api(vm, "post", "/fel_guatemala/emitter/do-get", {
            u: data.uuid,
          })
            .then((remitter) => {
              vm.uuid = data.uuid;
              vm.meta.name = data.name;
              vm.meta.provider = data.provider;
              if (data.set_as_default) {
                // console.log("setting as default");
                vm.meta.set_as_default = data.set_as_default;
              }
              if (data.provider)
                window
                  .jQuery(vm.$refs.provider)
                  .dropdown("set selected", data.provider);
              vm.meta.setup = remitter.setup;
              vm.meta.template = remitter.template;
            })
            .catch((err) => {
              error_toast(err);
            });
        }
        // vm.updateTransaction(data.uuid);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {
            window.jQuery(vm.$refs.tabss).find(".item").tab();
            window.jQuery(vm.$refs.provider).dropdown({
              onChange(value) {
                vm.meta.provider = value;
              },
            });

            vm.$refs.wysy.init();
          },
          onHide() {
            vm.form.form("reset");
            vm.uuid = "";
            vm.meta = {
              name: "",
              provider: "",
              setup: {},
              template: {
                html: "",
                js: "",
                css: "",
              },
            };
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          nit: ["empty"],
          name: ["empty"],
        },
      });
    },
    prov_setup_updated(setup) {
      this.meta.setup = setup;
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/fel_guatemala/emitter/do-save", {
        u: vm.uuid,
        m: vm.meta,
      })
        .then(() => {
          vm.$emit("created");
          window.jQuery(vm.$refs.modal).modal("hide");
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
